import {LabelTemplate} from 'constants/SampleConstants';
import * as net from 'util/Net';

export function fetchLabelTemplates(): JQueryPromise<{data: Array<LabelTemplate>}> {
  return net.getJSON('/1/api/label-templates');
}

export function createLabelTemplate(
  data: Pick<LabelTemplate, 'registryId' | 'name' | 'zplTemplate'>
): JQueryPromise<{labelTemplate: LabelTemplate}> {
  return net.postJSON({url: '/1/api/label-templates', data});
}

export function updateLabelTemplate(
  labelTemplateId: string,
  data: {
    name?: LabelTemplate['name'];
    zplTemplate?: LabelTemplate['zplTemplate'];
  }
): JQueryPromise<{labelTemplate: LabelTemplate}> {
  return net.patchJSON({url: `/1/api/label-templates/${labelTemplateId}`, data});
}

export function deleteLabelTemplate(labelTemplateId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/label-templates/${labelTemplateId}`});
}
